import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "excel-viewer h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center h-full"
}
const _hoisted_3 = {
  key: 1,
  class: "h-full flex flex-col"
}
const _hoisted_4 = { class: "sheet-tabs flex overflow-x-auto mb-2 bg-gray-100 border-b border-gray-300" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex-grow relative" }
const _hoisted_7 = {
  ref: "hotContainer",
  class: "w-full h-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "text-gray-500" }, "Loading spreadsheet data...", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheets, (sheet, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass([
          'px-4 py-2 text-sm font-medium transition-colors',
          _ctx.currentSheet === sheet
            ? 'bg-white border-l border-t border-r border-gray-300 text-blue-600 -mb-px'
            : 'text-gray-700 hover:bg-gray-200'
        ]),
                onClick: ($event: any) => (_ctx.selectSheet(sheet))
              }, _toDisplayString(sheet), 11, _hoisted_5))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, null, 512)
          ])
        ]))
  ]))
}